<template>
  <div class="row">
    <!-- First column-->
    <div class="col-12 col-lg-8 m-auto" style="back">
      <!-- Product Information -->
      <div class="card p-2">
        <div class="card-header py-0">
          <h3 class="mb-2">Course Lessons</h3>
          <p class="mb-2">
            Begin the process of assembling your course by crafting sections and lessons.
            Utilize your course outline as a framework for organizing your material and
            clearly delineating your sections and lessons. Should you plan to provide your
            course without charge, ensure that the combined duration of video content does
            not exceed a two-hour limit.
          </p>
          <div class="mb-1 text-warning">
            Please upload a video that is at least 1GB in size and upload one video at a
            time
          </div>
        </div>
        <div class="card-body py-0">
          <div class="border border-primary mb-2" v-for="(lesson, index) in lessons">
            <div class="p-2">
              <h5>
                <span class="text-primary"
                  >Lesson {{ index + 1 }} : {{ lesson.title }}</span
                >
                <vue-feather
                  type="edit-2"
                  size="12"
                  class="ml-1"
                  style="cursor: pointer; color: #00cfe8"
                  @click="showEditLessson(lesson.id)"
                ></vue-feather>
                <vue-feather
                  type="trash-2"
                  size="12"
                  class="ml-1 text-danger"
                  style="cursor: pointer"
                  @click="deleteCourse(lesson.id)"
                ></vue-feather>
              </h5>
              <div :ref="`main_net_dev_` + lesson.id">
                <div
                  class="border px-2 mt-1 content-show-upload"
                  style="width: 100%"
                  v-for="(video, video_index) in lesson.lesson_videos"
                  :key="index"
                >
                  <div class="" style="width: 100%; height: 60px; position: relative">
                    <div class="left-section">
                      <p style="/* line-height: 60px; */">
                        Lecture {{ video_index + 1 }}: {{ video.title }}
                        <!-- edit blue, trash red -->
                        <vue-feather
                          type="edit-2"
                          size="12"
                          class="ml-1"
                          style="cursor: pointer; color: #00cfe8"
                          @click="showEditTitle(video.id)"
                        ></vue-feather>
                        <!--  -->
                        <vue-feather
                          type="trash-2"
                          size="12"
                          class="ml-1 text-danger"
                          style="cursor: pointer"
                          @click="deleteLecture(video.id, lesson.id)"
                        ></vue-feather>
                      </p>
                    </div>
                    <div class="right-section">
                      <button
                        :id="`add_lecture_video_btn_` + video.id"
                        class="btn btn-outline-primary mr-1 content-show-upload-btn"
                        style="border-radius: 0px"
                        @click="showAddLectureVideo(video.id)"
                        :ref="'add_lecture_video_btn_' + video.id"
                      >
                        <span>+</span> Content
                      </button>
                    </div>
                  </div>
                  <!-- reached here -->
                  <div
                    class="mb-1 content-hide-upload"
                    style="height: auto; width: 100%"
                    :ref="'add_upload_view_' + video.id"
                    v-if="!video.content"
                  >
                    <h4 class="text-sm mb-1">Upload Video</h4>
                    <div class="form-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="blogCustomFile"
                          accept="video/*"
                          data-toggle="modal"
                          data-target="#larger"
                          @change="selectedVideo($event, video.id, lesson.id)"
                          enctype="multipart/form-data"
                        />
                        <label class="custom-file-label" for="blogCustomFile"
                          >Choose file</label
                        >
                      </div>
                    </div>
                    <!-- reached here -->
                    <div class="d-flex">
                      <div
                        class="progress mt-1"
                        style="width: 70%"
                        v-if="
                          percentCompleted[`percent_` + video.id] > 0 &&
                          percentCompleted[`percent_` + video.id] < 100
                        "
                      >
                        <div
                          class="progress-bar"
                          :style="`width:${percentCompleted[`percent_` + video.id]}%`"
                        ></div>
                      </div>
                      <div
                        v-if="
                          percentCompleted[`percent_` + video.id] > 0 &&
                          percentCompleted[`percent_` + video.id] < 100
                        "
                        style="margin: 9px"
                      >
                        {{ percentCompleted[`percent_` + video.id] }}%
                      </div>
                      <div
                        v-else-if="percentCompleted[`percent_` + video.id] == 100"
                        class="mt-2 text-primary"
                      >
                        <!-- todo handle draft and publish message -->
                        <div>Processing video...</div>
                      </div>
                      <div
                        v-else-if="processCompleted[`process_` + video.id] == true"
                        class="mt-2 text-primary"
                      >
                        Video uploaded successfully
                      </div>
                    </div>
                    <small
                      >Note: All files should be at least 720p and less than 1.0
                      GB.</small
                    >
                    <div class="mt-1">
                      <button
                        class="btn btn-outline-secondary mr-1"
                        style="border-radius: 0px"
                        @click="hideAddLectureVideo(video.id)"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                  <!-- reached here  -->
                  <div
                    :id="`add_upload_view_` + video.id"
                    class="mb-1 content-hide-upload"
                    style="height: auto; width: 100%"
                    :ref="'add_upload_view_' + video.id"
                    v-else
                  >
                    <div class="d-flex justify-content-between">
                      <div class="left-content">
                        <div class="d-flex">
                          <div class="innerVideo">
                            <div class="iconVideo">
                              <vue-feather
                                type="video"
                                size="42"
                                class="icon"
                              ></vue-feather>
                            </div>
                            <div
                              class="removeVids"
                              @click="removeVideo(lesson.id, video.id)"
                              style="cursor: pointer"
                            >
                              Remove
                            </div>
                          </div>
                          <div class="innerVideo ml-1" v-if="video.resources">
                            <div class="iconVideo">
                              <vue-feather
                                type="paperclip"
                                size="82"
                                class="icon"
                              ></vue-feather>
                            </div>
                            <div
                              class="removeVids"
                              @click="removeResource(lesson.id, video.id)"
                              style="cursor: pointer"
                            >
                              Remove
                            </div>
                          </div>
                        </div>
                        <!-- this is -->
                        <input
                          type="file"
                          class="custom-file-input"
                          :id="`add_lecture_resources_btn_` + video.id"
                          accept=".pdf"
                          data-toggle="modal"
                          data-target="#larger"
                          @change="selectedDocument($event, video.id, lesson.id)"
                          enctype="multipart/form-data"
                          hidden
                        />
                        <label
                          :for="`add_lecture_resources_btn_` + video.id"
                          class="btn btn-outline-primary mr-1 content-show-upload-btn mt-1"
                          style="border-radius: 0px"
                          v-if="!video.resources"
                        >
                          <span>+</span> Resources
                        </label>
                        <br />
                      </div>
                      <div>
                        <div class="d-flex">
                          <p>Free:</p>
                          &nbsp;
                          <toggle
                            v-model="is_free[`video_` + video.id]"
                            @change="saveFreeby(lesson.id, video.id, 1)"
                          />
                        </div>
                        <div class="d-flex">
                          <p>Course Preview:</p>
                          &nbsp;
                          <toggle
                            v-model="is_preview[`video_` + video.id]"
                            @change="saveFreeby(lesson.id, video.id, 0)"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="mt-1">
                      <button
                        class="btn btn-outline-danger mr-1"
                        style="border-radius: 0px"
                        @click="hideAddLectureVideo(video.id)"
                      >
                        <span>x</span> Close
                      </button>
                    </div>
                  </div>
                  <!-- Start Edit -->
                  <div
                    class="editTitle content-hide-view mb-1"
                    :ref="'edit_title_' + video.id"
                  >
                    <h5>Edit <Title></Title></h5>
                    <div class="form-group">
                      <input
                        class="form-control"
                        placeholder="Enter Lesson Title"
                        style="border-radius: 0px"
                        v-model="lecture_title_vid[`video_${video.id}`]"
                      />
                    </div>
                    <div class="d-flex justify-content-end mt-1">
                      <a
                        class="btn btn-outline-primary btn-sm mr-1 border-0"
                        style="border-radius: 0px"
                        @click="hideEditLecture(video.id)"
                      >
                        cancel
                      </a>
                      <a
                        class="btn btn-primary btn-sm"
                        style="border-radius: 0px"
                        @click="updateLecture(lesson.id, video.id)"
                      >
                        Edit Lecture
                      </a>
                    </div>
                  </div>
                  <!-- end edit -->
                </div>
              </div>
              <!--  -->
              <div
                class="border add-sub-lesson p-2 mt-1 content-hide-view"
                :ref="'edit_lecture_view_' + lesson.id"
                v-show="activeRef == lesson.id"
              >
                <h5>Edit Title</h5>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="Enter Lesson Title"
                    style="border-radius: 0px"
                    v-model="lesson_title"
                  />
                  <input
                    class="form-control mt-2"
                    placeholder="Enter Learn Objective "
                    style="border-radius: 0px"
                    v-model="lesson_description"
                  />
                </div>
                <div class="d-flex justify-content-end mt-1">
                  <a
                    class="btn btn-outline-primary btn-sm mr-1 border-0"
                    style="border-radius: 0px"
                    @click="hideEditLesson(lesson.id)"
                  >
                    cancel
                  </a>
                  <a
                    class="btn btn-primary btn-sm"
                    style="border-radius: 0px"
                    @click="updateLesson(lesson.id)"
                  >
                    Edit Title
                  </a>
                </div>
              </div>
              <!-- Start of Add Lecture -->
              <div
                class="border add-sub-lesson p-2 mt-1 content-hide-view"
                :ref="'add_lecture_view_' + lesson.id"
              >
                <h5>New Lecture</h5>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="Enter Lesson Title"
                    style="border-radius: 0px"
                    v-model="lecture_title"
                  />
                </div>
                <div class="d-flex justify-content-end mt-1">
                  <a
                    class="btn btn-outline-primary btn-sm mr-1 border-0"
                    style="border-radius: 0px"
                    @click="hideAddLecture(lesson.id)"
                  >
                    cancel
                  </a>
                  <a
                    class="btn btn-primary btn-sm"
                    style="border-radius: 0px"
                    @click="addLecture(lesson.id)"
                  >
                    Add Lecture
                  </a>
                </div>
              </div>

              <!-- End of Add Lecture -->
              <!-- Add Lecture Button-->
              <button
                class="btn btn-outline-primary my-2 content-show-btn"
                style="border-radius: 0px"
                @click="showAddLecture(lesson.id)"
                :ref="'add_lecture_btn_' + lesson.id"
              >
                <span>+</span> Add Sub-Lesson
              </button>
              <!-- End of Add Lecture Button-->
            </div>
          </div>
        </div>
        <div class="card-body py-0">
          <!--  -->
          <div class="border border-primary p-2" v-show="viewAddLesson">
            <h5>New Lecture</h5>
            <div class="form-group">
              <input
                class="form-control mb-2"
                placeholder="Enter Lesson Title"
                style="border-radius: 0px"
                v-model="lesson_title"
              />
              <input
                class="form-control"
                placeholder="Enter Learn Objective "
                style="border-radius: 0px"
                v-model="lesson_description"
              />
            </div>
            <div class="d-flex justify-content-end mt-1">
              <a
                class="btn btn-outline-primary btn-sm mr-1 border-0"
                style="border-radius: 0px"
                @click="showAddLesson(id)"
              >
                cancel
              </a>
              <a
                class="btn btn-primary btn-sm"
                style="border-radius: 0px"
                @click="addLesson"
              >
                Add Lesson
              </a>
            </div>
          </div>
          <!--  -->
          <button
            class="btn btn-outline-primary"
            style="border-radius: 0px"
            :class="!viewAddLesson ? 'content-show-btn' : 'content-hide-btn'"
            @click="showAddLesson(id)"
          >
            <span>+</span> Add Lesson
          </button>
          <button
            class="btn btn-primary float-right"
            style="border-radius: 0px"
            @click="UpdateCourse()"
          >
            <span>+</span> Publish Course
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Toggle from "@vueform/toggle";
import { ref, reactive, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2";
export default {
  components: {
    Toggle,
  },
  setup() {
    const activeRef = ref(0),
      devRefs = ref(),
      lessons = ref([]),
      uploaded = ref([]),
      percentCompleted = ref([]),
      chunks = reactive({}),
      videoFile = ref([]),
      pdfFile = ref([]),
      file = ref(),
      is_free = reactive({}),
      is_preview = reactive({}),
      lesson_id = ref(),
      video_id = ref(),
      route = useRoute(),
      router = useRouter(),
      videoToUpdate = ref([]),
      processCompleted = ref([]);
    function update(lesson_id, video_id, data) {
      const courseToUpdate = lessons.value.find((course) => course.id === lesson_id);
      const lesson_videos = courseToUpdate.lesson_videos;
      const find_video = _.find(lesson_videos, { id: video_id });
      if (find_video) {
        find_video.content = data;
        let add_lecture_video_btn, add_upload_view;
        add_lecture_video_btn = document.getElementById(
          `add_lecture_video_btn_${video_id}`
        );
        add_upload_view = document.getElementById(`add_upload_view_${video_id}`);
        if (add_lecture_video_btn) {
          add_lecture_video_btn.classList.remove("content-hide-upload-btn");
          add_lecture_video_btn.classList.add("content-show-upload-btn");

          if (add_upload_view) {
            add_upload_view.classList.remove("content-show-upload");
            add_upload_view.classList.add("content-hide-upload");
          }
        }
      }
    }
    function uploadVideo() {
      let $this = this;

      _.forEach(videoToUpdate.value, function (value, key) {
        const chunkVal = chunks[`chunks_${value.video_id}`];
        if (_.size(chunkVal) > 0) {
          let formData = new FormData();
          formData.append("is_last", chunkVal.length === 1);
          formData.append(
            "file",
            chunkVal[0],
            `${videoFile.value[`file_` + value.video_id].name}.part`
          );

          let route = router.resolve({
            name: "lecture-video-upload",
            params: {
              lesson: value.lesson_video,
              video: value.video_id,
            },
          });
          let config = {
            method: "POST",
            url: route.href,
            data: formData,
            headers: {
              "Content-Type": "application/octet-stream",
            },
            onUploadProgress: (event) => {
              uploaded.value[`upload_${value.video_id}`] += event.loaded;
            },
          };
          percentCompleted.value[`percent_${value.video_id}`] = Math.floor(
            (uploaded.value[`upload_${value.video_id}`] * 100) /
              videoFile.value[`file_` + value.video_id].size
          );
          axios(config)
            .then(({ data }) => {
              chunkVal.shift();
              if (data.message == "completed") {
                processCompleted.value[`process_${value.video_id}`] = true;
                uploaded.value[`upload_${value.video_id}`] = 0;
                percentCompleted.value[`percent_${value.video_id}`] = 0;
                update(value.lesson_video, value.video_id, data.data);
                toastr.success(
                  "Video uploaded successfully, Proceed to the next course",
                  "Success!"
                );
                setTimeout(() => {
                  processCompleted.value[`process_${value.video_id}`] = false;
                }, 1000);
              }
            })
            .catch((error) => {});
        }
      });
    }
    return {
      lessons,
      lesson_title: ref(),
      lesson_description: ref(),
      lecture_title: ref(),
      lecture_title_vid: reactive({}),
      opened: ref(false),
      viewAddLecture: ref(false),
      viewAddLesson: ref(false),
      editableContent: ref("Getting Started with Creditfixrr"),
      canEditableContent: ref(false),
      percentCompleted,
      processCompleted,
      videoToUpdate,
      uploadVideo,
      is_preview,
      videoFile,
      pdfFile,
      lesson_id,
      activeRef,
      is_free,
      video_id,
      uploaded,
      router,
      update,
      devRefs,
      chunks,
      route,
      file,
    };
  },
  watch: {
    chunks: {
      deep: true,
      handler(newVal, oldVal) {
        this.uploadVideo();
      },
    },
    videoToUpdate: {
      deep: true,
      handler(newVal, oldVal) {
        // Do something when chunksData changes
      },
    },
  },
  mounted() {
    this.getLessons();
  },
  methods: {
    showContent(id, target) {
      this.opened = !this.opened;
    },
    showAddLecture(id, target) {
      const refName = `add_lecture_btn_${id}`;
      const element = this.$refs[refName][0];
      if (element) {
        element.classList.remove("content-show-btn");
        element.classList.add("content-hide-btn");
        const refContentName = `add_lecture_view_${id}`;
        const elementView = this.$refs[refContentName][0];
        if (elementView) {
          elementView.classList.remove("content-hide-view");
          elementView.classList.add("content-show-view");
        }
      }
    },
    hideAddLecture(id, target) {
      const refName = `add_lecture_btn_${id}`;
      const element = this.$refs[refName][0];
      if (element) {
        element.classList.remove("content-hide-btn");
        element.classList.add("content-show-btn");
        const refContentName = `add_lecture_view_${id}`;
        const elementView = this.$refs[refContentName][0];
        if (elementView) {
          elementView.classList.remove("content-show-view");
          elementView.classList.add("content-hide-view");
        }
      }
    },
    showAddLectureVideo(id, target) {
      const refName = `add_lecture_video_btn_${id}`;

      const element = this.$refs[refName][0];

      if (element) {
        element.classList.remove("content-show-upload-btn");
        element.classList.add("content-hide-upload-btn");

        const refContentName = `add_upload_view_${id}`;
        const elementView = this.$refs[refContentName][0];
        if (elementView) {
          elementView.classList.remove("content-hide-upload");
          elementView.classList.add("content-show-upload");
        }
      }
    },
    hideAddLectureVideo(id, target) {
      const refName = `add_lecture_video_btn_${id}`;

      const element = this.$refs[refName][0];

      if (element) {
        element.classList.remove("content-hide-upload-btn");
        element.classList.add("content-show-upload-btn");

        const refContentName = `add_upload_view_${id}`;
        const elementView = this.$refs[refContentName][0];
        if (elementView) {
          elementView.classList.remove("content-show-upload");
          elementView.classList.add("content-hide-upload");
        }
      }
    },
    showEditTitle(id, target) {
      const refName = `edit_title_${id}`;

      const element = this.$refs[refName][0];

      if (element) {
        element.classList.remove("content-hide-view");
        element.classList.add("content-show-view");
      }
    },
    hideEditLecture(id) {
      const refName = `edit_title_${id}`;

      const element = this.$refs[refName][0];

      if (element) {
        element.classList.remove("content-show-view");
        element.classList.add("content-hide-view");
      }
    },
    showEditLessson(id, target) {
      this.activeRef = id;
      const refName = `edit_lecture_view_${id}`;

      const element = this.$refs[refName][0];

      const refContentName = `main_net_dev_${id}`;
      const elementView = this.$refs[refContentName][0];
      if (element) {
        element.classList.remove("content-hide-view");
        element.classList.add("content-show-view");
        if (elementView) {
          elementView.classList.remove("content-show-upload");
          elementView.classList.add("content-hide-upload");
        }
      }
    },
    hideEditLesson(id) {
      this.activeRef = 0;
      const refName = `edit_lecture_view_${id}`;

      const element = this.$refs[refName][0];
      const refContentName = `main_net_dev_${id}`;
      const elementView = this.$refs[refContentName][0];
      if (element) {
        element.classList.remove("content-show-view");
        element.classList.add("content-hide-view");
        if (elementView) {
          elementView.classList.remove("content-hide-upload");
          elementView.classList.add("content-show-upload");
        }
      }
    },
    showAddLesson(id, target) {
      this.viewAddLesson = !this.viewAddLesson;
    },
    editableContent(id, target) {
      this.canEditableContent = !this.canEditableContent;
    },
    deleteLesson() {
      Swal.fire({
        title: "Are you sure you want to delete this lesson?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(function (result) {
        if (result.value) {
        }
      });
    },
    getLessons() {
      let $this = this;
      const route = this.$router.resolve({
        name: "course-lessons",
        params: {
          course: this.$route.params.course,
        },
      });

      axios
        .post(route.href)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          let chunksId = [];

          response.data.data.forEach((element) => {
            element.lesson_videos.forEach((elementNew) => {
              $this.is_free[`video_${elementNew.id}`] = elementNew.is_free;
              $this.is_preview[`video_${elementNew.id}`] = elementNew.is_preview;
              $this.lecture_title_vid[`video_${elementNew.id}`] = elementNew.title;
              chunksId.push(elementNew.id);
            });
          });
          chunksId.forEach((element) => {
            $this.chunks[`chunks_${element}`] = [];
            $this.processCompleted[`process_${element}`] = false;
            $this.uploaded[`upload_${element}`] = 0;
            $this.percentCompleted[`percent_${element}`] = 0;
          });
          $this.lessons = response.data.data;
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addLesson() {
      let $this = this;
      const route = this.$router.resolve({
        name: "lesson-create",
        params: {
          course: this.$route.params.course,
        },
      });

      const payload = {
        title: this.lesson_title,
        slug: this.lesson_title,
        description: this.lesson_description,
      };
      axios
        .post(route.href, payload)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          $this.viewAddLesson = false;
          let lesson_data = response.data.data;
          $this.lessons.push(lesson_data);

          toastr.success(response.data.message, "Success!");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateLesson(id) {
      let $this = this;
      const route = this.$router.resolve({
        name: "lesson-update",
        params: {
          course: this.$route.params.course,
          lesson: id,
        },
      });

      const payload = {
        title: this.lesson_title,
        slug: this.lesson_title,
        description: this.lesson_description,
        is_free: false,
        is_preview: false,
      };
      axios
        .post(route.href, payload)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          $this.viewAddLesson = false;
          $this.getLessons();
          $this.hideEditLesson(id);
          $this.resetLessonInput();
          toastr.success(response.data.message, "Success!");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addLecture(id) {
      let $this = this;
      const courseToUpdate = this.lessons.find((course) => course.id === id);
      const route = this.$router.resolve({
        name: "lecture-create",
        params: {
          lesson: id,
        },
      });

      const payload = {
        title: this.lecture_title,
        slug: this.lecture_title,
      };
      axios
        .post(route.href, payload)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          $this.hideAddLecture(id);
          if (courseToUpdate) {
            let lessson_data = response.data.data;
            courseToUpdate.lesson_videos.push(lessson_data);
            $this.chunks[`chunks_${lessson_data.id}`] = [];
            $this.processCompleted[`process_${lessson_data.id}`] = false;
            $this.uploaded[`upload_${lessson_data.id}`] = 0;
            $this.percentCompleted[`percent_${lessson_data.id}`] = 0;
            $this.is_free[`video_${lessson_data.id}`] = false;
            $this.is_preview[`video_${lessson_data.id}`] = false;
            $this.lecture_title_vid[`video_${lessson_data.id}`] = lessson_data.title;
          }
          $this.lecture_title = null;
          toastr.success(response.data.message, "Success!");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateLecture(id, lesson_video) {
      let $this = this;
      const route = this.$router.resolve({
        name: "lecture-update",
        params: {
          lesson: id,
          video: lesson_video,
        },
      });

      const payload = {
        title: this.lecture_title_vid[`video_${lesson_video}`],
        slug: this.lecture_title_vid[`video_${lesson_video}`],
      };
      axios
        .post(route.href, payload)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          $this.hideEditLecture(lesson_video);
          $this.getLessons();
          toastr.success(response.data.message, "Success!");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteLecture(id, lesson_id) {
      let $this = this;
      const courseToUpdate = this.lessons.find((course) => course.id === lesson_id);
      const route = this.$router.resolve({
        name: "lecture-delete",
        params: {
          lesson: lesson_id,
          video: id,
        },
      });
      Swal.fire({
        title: "Are you sure you want to delete this lesson?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(function (result) {
        if (result.value) {
          axios
            .post(route.href)
            .then(function (response) {
              if (response.data.error == true) {
                toastr.error(response.data.message, "Error!");
                return;
              }
              if (courseToUpdate) {
                const newArray = courseToUpdate.lesson_videos.filter(
                  (item) => item.id !== response.data.data.id
                );
                courseToUpdate.lesson_videos = newArray;
              }
              toastr.success(response.data.message, "Success!");
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    deleteCourse(lesson_id) {
      let $this = this;
      const courseToUpdate = this.lessons.find((course) => course.id === lesson_id);
      const route = this.$router.resolve({
        name: "lesson-delete",
        params: {
          course: this.$route.params.course,
          lesson: lesson_id,
        },
      });
      Swal.fire({
        title: "Are you sure you want to delete this lesson?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(function (result) {
        if (result.value) {
          axios
            .post(route.href)
            .then(function (response) {
              if (response.data.error == true) {
                toastr.error(response.data.message, "Error!");
                return;
              }
              $this.getLessons();
              toastr.success(response.data.message, "Success!");
              return;
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    removeVideo(lesson_id, video_id) {
      let $this = this;
      const route = this.$router.resolve({
        name: "lecture-delete-video",
        params: {
          lesson: lesson_id,
          video: video_id,
        },
      });
      Swal.fire({
        title: "Are you sure you want to delete this video?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(function (result) {
        if (result.value) {
          const courseToUpdate = $this.lessons.find((course) => course.id === lesson_id);
          const lesson_videos = courseToUpdate.lesson_videos;
          const find_video = _.find(lesson_videos, { id: video_id });
          axios
            .post(route.href)
            .then(function (response) {
              if (response.data.error == true) {
                toastr.error(response.data.message, "Error!");
                return;
              }
              find_video.content = null;

              $this.hideAddLectureVideo(video_id);
              toastr.success(response.data.message, "Success!");
              return;
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    removeResource(lesson_id, video_id) {
      let $this = this;
      const route = this.$router.resolve({
        name: "lecture-delete-reasource",
        params: {
          lesson: lesson_id,
          video: video_id,
        },
      });
      Swal.fire({
        title: "Are you sure you want to delete this PDF File?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(function (result) {
        if (result.value) {
          const courseToUpdate = $this.lessons.find((course) => course.id === lesson_id);
          const lesson_videos = courseToUpdate.lesson_videos;
          const find_video = _.find(lesson_videos, { id: video_id });
          axios
            .post(route.href)
            .then(function (response) {
              if (response.data.error == true) {
                toastr.error(response.data.message, "Error!");
                return;
              }
              find_video.resources = null;
              toastr.success(response.data.message, "Success!");
              return;
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },

    saveFreeby(id, lesson_video, type) {
      let $this = this;
      const route = this.$router.resolve({
        name: "lecture-update",
        params: {
          lesson: id,
          video: lesson_video,
        },
      });
      let payload = {};
      if (type == 1) {
        payload = {
          is_free: this.is_free[`video_${lesson_video}`],
        };
      } else {
        payload = {
          is_preview: this.is_preview[`video_${lesson_video}`],
        };
      }
      axios
        .post(route.href, payload)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          toastr.success(response.data.message, "Success!");
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectedVideo(event, video_id, lesson_video) {
      this.videoFile[`file_` + video_id] = event.target.files[0];
      this.videoToUpdate.push({ lesson_video: lesson_video, video_id: video_id });
      this.createChucks(lesson_video, video_id);
    },
    selectedDocument(event, video_id, lesson_video) {
      let $this = this;
      this.pdfFile[`file_` + video_id] = event.target.files[0];
      const formData = new FormData();
      formData.append("pdf_file", this.pdfFile[`file_` + video_id]);
      let route = this.$router.resolve({
        name: "lesson-upload-resource",
        params: {
          lesson: lesson_video,
          video: video_id,
        },
      });
      axios
        .post(route.href, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          const course = $this.lessons.find((course) => course.id === lesson_video);
          let foundVideo = _.find(course.lesson_videos, { id: video_id });
          foundVideo.resources = response.data.data;
          toastr.success(response.data.message, "Success!");
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
      console.log(this.pdfFile[`file_` + video_id]);
    },
    createChucks(lesson_video, video_id) {
      this.chunks["chunks_" + video_id] = [];
      let size = 204800,
        chunks = Math.ceil(this.videoFile[`file_` + video_id].size / size);
      for (let i = 0; i < chunks; i++) {
        this.chunks[`chunks_` + video_id].push(
          this.videoFile[`file_` + video_id].slice(
            i * size,
            Math.min(i * size + size, this.videoFile[`file_` + video_id].size),
            this.videoFile[`file_` + video_id].type
          )
        );
      }
    },
    resetLessonInput() {
      this.lesson_title = null;
      this.lesson_title = null;
      this.lesson_description = null;
      this.is_free = null;
      this.is_preview = false;
    },
    UpdateCourse() {
      const $this = this;
      const route = this.$router.resolve({
        name: "course-update",
        params: {
          course: this.$route.params.course,
        },
      });
      const payload = {
        published: true,
      };
      axios
        .post(route.href, payload)
        .then(function (response) {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          toastr.success(response.data.message, "Success!");
          $this.$router.push({ name: "admin-courses" });
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.left-section {
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translate(0px, -30%);
  height: auto;
}
.right-section {
  position: absolute;
  right: 0px;
  transform: translate(0px, -50%);
  top: 50%;
}
.content-show-upload-btn {
  display: inline-block;
}
.content-hide-upload-btn {
  display: none;
}
.content-hide-btn {
  visibility: hidden;
}
.content-show-btn {
  visibility: visible;
}
.content-show-view {
  display: block;
}
.content-hide-view {
  display: none;
}
.content-show-upload {
  display: block;
}
.content-hide-upload {
  display: none;
}
.innerVideo {
  height: 100px;
  width: 100px;
  background: silver;
  position: relative;
}
.removeVids {
  height: 25px;
  width: 100%;
  background: #ea5455;
  color: white;
  text-align: center;
  line-height: 25px;
  font-weight: 900;
  bottom: 0px;
  position: absolute;
}
.iconVideo .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
<style src="@vueform/toggle/themes/default.css"></style>
